export default __webpack_public_path__ + "static/media/event-cleaning.634b23c2.svg";